import { render, staticRenderFns } from "./FormProjectLocale.vue?vue&type=template&id=4180f498&scoped=true&"
import script from "./FormProjectLocale.vue?vue&type=script&lang=js&"
export * from "./FormProjectLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4180f498",
  null
  
)

export default component.exports